import { colors2 } from "oolib";
import { globalScrollbarStyling } from "oolib/dist/v2/themes/globalStyles";
import styled, { css } from "styled-components";
import "./responsive.css";

export const Z_INDEX = {
  WIDGET_FORM_HEADER: 100,
  ADD_WIDGET_BTN_PRIMARY: 999,
  ADD_WIDGET_BTN_SECONDARY: 100,
  REPORTS_HEADER: 10000,
  WIDGET_CONFIG_STICKY_HEADER: 10000,
};

// Main Layout Components
export const StyledLoadingContainer = styled.div`
  display: grid;
  grid-template-columns: 300px 1fr;
  gap: 0.8rem;
  height: ${props => `calc(100vh - ${props.headerHeight})`};
  padding-bottom: 0.4rem;
`;

export const StyledMainContent = styled.div.attrs({ className: "report-main-content" })`
  padding: ${props => props.padding}px;
  padding-left: ${props => props.paddingLeft}px;
  min-height: ${props => props.minHeight};
  background: ${colors2.grey2};
  display: flex;
  flex-direction: column;
  gap: 1.4rem;

  ${({ $viewMode }) => $viewMode && css`
    max-width: 1200px;
    margin-inline: auto;
    background: ${colors2.white};
  `}
`;

export const StyledSidebarToggleButton = styled.div`
  position: absolute;
  left: ${props => props.left}px;
  top: ${props => props.top}px;
`;

// Sidebar Components
export const StyledWidgetFormHeader = styled.div`
  padding: 0.4rem 1rem 0.4rem 0.4rem;
  display: flex;
  align-items: center;
  justify-content: space-between;
  z-index: ${Z_INDEX.WIDGET_FORM_HEADER};
  background: ${colors2.white};
  position: sticky;
  top: 0;
`;

export const StyledFilterHeader = styled.div`
  display: flex;
  padding: ${({ $compact, $viewMode }) => $compact ? $viewMode ? '0.5rem 0.6rem 0.5rem 1.6rem' : '0.5rem 1.6rem' : '1rem 1.6rem'};
  justify-content: space-between;
  border-bottom: ${({ $viewMode, $compact }) => ($viewMode || !$compact) ? `1px solid ${colors2.grey10}` : 'none'};
`;

// Grid and Widget Components
export const StyledGridContainer = styled.div.attrs({ className: "report-grid" })`
  position: relative;
  display: grid;
  gap: ${props => props.gap}px;
  grid-template-columns: ${props => `repeat(${props.columns}, minmax(0, 1fr))`};
`;

export const StyledCompWrapper = styled.div`
  position: relative;
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items: center;
  overflow-y: auto;
  ${globalScrollbarStyling}

  &:has(> .widget-error-state) {
    height: 100%;
  }
`;

export const StyledAddWidgetButtonContainer = styled.div`
  position: relative;
`;

export const StyledDropIndicator = styled.div`
  position: absolute;
  background: ${colors2.blue};
  border-radius: 2px;
  z-index: 10;
  pointer-events: none;
  ${({ side, $gridGap = 12 }) => {
    const offset = Math.floor($gridGap / 2) + 1;
    switch (side) {
      case "left": return `top: 0; bottom: 0; width: 3px; left: -${offset}px;`;
      case "right": return `top: 0; bottom: 0; width: 3px; right: -${offset}px;`;
      case "top": return `left: 0; right: 0; height: 3px; top: -${offset}px;`;
      case "bottom": return `left: 0; right: 0; height: 3px; bottom: -${offset}px;`;
      default: return "";
    }
  }}
`;